// extracted by mini-css-extract-plugin
export default {"LayoutsMobileMenu":"LayoutsMobileMenu_LayoutsMobileMenu__vYiTN","layoutsContainer":"LayoutsMobileMenu_layoutsContainer__E3zP0"};